export const isNullOrUndefined = (value) => value === null || value === undefined;
